module.exports = __webpack_public_path__ + "static/media/email-icon-v2.34d850a3.svg";